import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';

export default function useLocationConnection() {
  const dispatch = useDispatch();
  const [, setCookie] = useCookies(['location_granted']);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState('');
  const inFlight = useRef(false);
  const mounted = useRef(true);
  useEffect(() => { mounted.current = true; return () => { mounted.current = false; }; }, []);

  function requestLocation() {
    if (inFlight.current) return;
    setError('');
    if (!navigator.geolocation) {
      setCookie('location_granted', false, { path: '/' });
      dispatch({ type: 'Location_Request_Declined' });
      setError('This browser can’t access location. Open the QR link in your phone’s browser.');
      return;
    }
    inFlight.current = true;
    setPending(true);
    navigator.geolocation.getCurrentPosition(position => {
      if (!mounted.current) return;
      inFlight.current = false;
      setPending(false);
      // Permission opens the existing QR lookup flow; driver proximity is checked there.
      dispatch({ type: 'Pax_Coords_Update', payload: { coords: [position.coords.latitude, position.coords.longitude] } });
      setCookie('location_granted', true, { path: '/' });
      dispatch({ type: 'Location_Request_Granted' });
      dispatch({ type: 'Location_Error_Reset' });
    }, failure => {
      if (!mounted.current) return;
      inFlight.current = false;
      setPending(false);
      dispatch({ type: 'Location_Request_Declined' });
      setCookie('location_granted', false, { path: '/' });
      if (failure.code === 1) {
        dispatch({ type: 'Location_Error_Denied' });
        setError('Location is blocked. Allow it in your browser’s site settings to continue.');
      } else {
        setError(failure.code === 3 ? 'The location request timed out. Please try again.' : 'Your location is unavailable right now. Please try again.');
      }
    }, { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
  }
  return { pending, error, requestLocation };
}
